import { initMixpanel, resetMixpanel, setMixpanelUser } from "./mixpanel";
import { trackAggregatedStudentSummary, trackProductEvent } from "./track";
import { flushWebVitals } from "./performance";
import { canTrackMixpanel } from "./consent";
export * from "./clickTracking";
export { trackProductEvent, trackAggregatedStudentSummary };

export const initializeAnalytics = ({ token, user }) => {
  // Always initialize Mixpanel so we can emit limited, consent-gated events.
  const didInit = initMixpanel({ token, enabled: true });
  if (didInit) {
    setMixpanelUser(user);
    flushWebVitals(user);
  }
};

